<template>
   <div class="conf-con">
                            <div class="intro-pic">
                                <img src="../../../assets/images/13.jpg" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第十三次全国代表大会简介</p>
                            <p class="margin1">1987年10月25日至11月1日在北京举行。赵紫阳作《沿着有中国特色的社会主义道路前进》的报告。大会提出并系统阐述了社会主义初级阶段理论，制定了党在社会主义初级阶段的基本路线，制定了“三步走”发展战略和各项改革任务。大会通过了《关于十二届中央委员会报告的决议》、《关于〈中国共产党章程部分条文修正案〉的决议》、《关于中央顾问委员会工作报告的决议》和《关于中央纪律检查委员会工作报告的决议》。大会选举了由175名委员和110名候补委员组成的中央委员会，选举了由200名委员组成的中央顾问委员会和由69名委员组成的中央纪律检查委员会。随后召开的十三届一中全会选举了中央政治局及其常务委员会；选举赵紫阳为中央委员会总书记；决定邓小平为中央军事委员会主席；批准陈云为中央顾问委员会主任，乔石为中央纪律检查委员会书记。</p>
                        </div>
</template>

<script>
export default {

}
</script>

<style>

</style>